var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HrApproval',{attrs:{"loading":_vm.sendingHRApproval,"disable":_vm.sendingHRApproval,"companyName":_vm.userProfile.companyName},on:{"click:sendHrApproval":_vm.emailMyCompany,"to:credit-check":_vm.toCreditCheckPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }